import { Container } from "inversify";
import {ICaptcha, CaptchaProvider} from "../features/Captcha/Captcha";
import {ReactElement} from "react";

export const container = new Container();

container.bind<ICaptcha<ReactElement>>("captchaProvider").to(CaptchaProvider);
